var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.handelItem(item.id)}}},[_c('img',{attrs:{"src":item.src,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }